import React from 'react';
import { Tag } from 'antd';
import type { SidebarBadge, SidebarMenuItem } from './menu.types';

const badgeColors: Record<NonNullable<SidebarBadge['tone']>, string> = {
    default: 'default',
    info: 'blue',
    success: 'green',
    warning: 'gold',
    error: 'red',
};

export const MenuLabel: React.FC<
    Pick<SidebarMenuItem, 'label' | 'meta' | 'suffixIcon'>
> = ({ label, meta, suffixIcon }) => (
    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <span>{label}</span>
        {meta?.badges?.map((badge) => (
            <Tag
                key={`${badge.label}-${badge.tone ?? 'default'}`}
                className="sidebar-menu-badge"
                color={badgeColors[badge.tone ?? 'default']}
                variant="filled"
                style={{ fontSize: 10, fontWeight: 700 }}
            >
                {badge.label}
            </Tag>
        ))}
        {suffixIcon && (
            <span style={{ display: 'inline-flex', marginLeft: 'auto' }}>
                {suffixIcon}
            </span>
        )}
    </span>
);
